import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtclubRatingComponent } from './utclub-rating.component';
import { PipesModule } from 'src/app/pipes/pipes.module';



@NgModule({
  declarations: [
    UtclubRatingComponent
  ],
  exports: [
    UtclubRatingComponent
  ],
  imports: [
    CommonModule,

    PipesModule
  ]
})
export class UtclubRatingModule { }
